export const FOOTER_BLOCK_s6 = {
  "blockType": "FOOTER",
  "blockDesign": "FooterDesign2",
  "editFormName": "FOOTER_FORM_2",
  "styleProps": {
    "background-color": "#0F0F0F",
    "padding": "50px 50px 50px 50px",
    "color": "#ffffff"
  },
  "metaDataId": 1746353444918,
  "company": {
    "description": {
      "list": [
        "Navdic 2023. All rights reserved."
      ]
    },
    "name": {
      "text": "✦ Predic",
      "styleProps": {
        "color": "#ffffff",
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "margin": "0px 0px 20px 0px",
        "font-weight": "700"
      }
    },
    "copy": {
      "text": "Transforming Businesses with Innovative Software Solutions",
      "styleProps": {
        "margin": "120px 0px 60px 0px",
        "color": "#ffffff",
        "font-size": "1rem",
        "line-height": "1.5rem",
        "font-weight": "500"
      },
      "stylePropsTab": {
        "margin": "80px 0px 120px 0px"
      },
      "stylePropsMob": {
        "margin": "60px 0px 60px 0px"
      }
    },
    "styleProps": {
      "width": "100%",
      "background-color": "",
      "padding": "20px 20px 20px 20px",
      "color": "#808080"
    },
    "logo": {
      "text": ""
    }
  },
  "column1": {
    "links": [
      {
        "label": {
          "text": "About",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#808080",
            "padding-bottom": "10px",
            "display": "inline-block",
            "padding": "0px 0px 10px 0px"
          },
          "stylePropsTab": {
            "font-size": "1.5rem",
            "line-height": "2rem"
          }
        },
        "url": "#about"
      },
      {
        "label": {
          "text": "Products",
          "styleProps": {
            "color": "#808080",
            "padding-left": "10px",
            "padding": "0px 0px 10px 0px",
            "font-size": "1rem"
          }
        },
        "url": "#products"
      },
      {
        "label": {
          "text": "Services",
          "styleProps": {
            "color": "#808080",
            "padding": "0px 0px 10px 0px",
            "margin": "0px 0px 0px 0px"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "Company",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff"
      }
    },
    "styleProps": {
      "width": "none",
      "color": "#cccccc",
      "background-color": "",
      "border-radius": "0px",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column2": {
    "links": [
      {
        "label": {
          "text": "hello@promosite.com",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#808080",
            "padding": "0px 0px 10px 0px"
          }
        },
        "url": "fasty"
      },
      {
        "label": {
          "text": "careers@promosite.com",
          "styleProps": {
            "color": "#808080",
            "padding": "0px 0px 10px 0px"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "Get in touch",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff"
      }
    },
    "styleProps": {
      "background-color": "",
      "width": "100%",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column4": {
    "title": {
      "text": "Connect",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff"
      }
    },
    "links": [
      {
        "label": {
          "text": "Facebook",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 0px 0px 0px",
            "color": "#333333"
          }
        },
        "url": "http://facebook.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676180930331.png",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 10px 0px 0px"
          }
        }
      },
      {
        "label": {
          "text": "Twitter"
        },
        "url": "http://twitter.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676180951924.png",
          "styleProps": {
            "margin": "0px 10px 0px 0px"
          }
        }
      },
      {
        "label": {
          "text": "Pinterest",
          "styleProps": {
            "padding": "0px 0px 0px 0px"
          }
        },
        "url": "",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676181521667.png"
        }
      }
    ],
    "styleProps": {
      "background-color": "",
      "padding": "20px 20px 20px 20px"
    },
    "type": "only_icon"
  },
  "bottom_links": {
    "links": [
      {
        "label": {
          "text": "Terms & Conditions",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Privacy Policy",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Disclaimer",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      }
    ],
    "styleProps": {
      "padding": "50px 0px 50px 0px",
      "background-color": "",
      "font-size": "1rem",
      "line-height": "1.5rem",
      "color": "#ffffff",
      "margin": "120px 0px 0px 0px"
    }
  },
  "afterIndex": 27,
  "blockId": 1746353444918
}